import { render, staticRenderFns } from "./project-templates.vue?vue&type=template&id=e1f4de4c"
import script from "./project-templates.vue?vue&type=script&lang=js"
export * from "./project-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports